 
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import InputField from "../../../../components/InputField";
import api from "../../../../api/api";
import BackButton from "../../../../components/BackButton";
 
const ViewEnquiryDetails = () => {
  const { id } = useParams();
  const [enquiry, setEnquiry] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
 
  useEffect(() => {
    const fetchEnquiry = async () => {
      try {
        const response = await api.get(`/enquiry/viewEnquiry/${id}`);
        setEnquiry(response.data);
      } catch (err) {
        console.error("Error fetching enquiry:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchEnquiry();
  }, [id]);
 
  if (loading) return <p className="p-3">Loading enquiry...</p>;
  if (error) return <p className="p-3 text-danger">Failed to load enquiry.</p>;
  if (!enquiry) return <p className="p-3">No enquiry found.</p>;
 
  return (
    <div className="container-fluid ">
      {/* Header & Breadcrumbs */}
       <BackButton />
      
      <div className="row g-3">
        <div className="col-sm-6 col-md-4">
          <InputField label="Incoterm" value={enquiry.incoterm || ""} disabled={true} />
        </div>
        <div className="col-sm-6 col-md-4">
          <InputField label="Shipper Name" value={enquiry.first_shipper_name || ""} disabled={true} />
        </div>
        <div className="col-sm-6 col-md-4">
          <InputField label="Consignee Name" value={enquiry.first_consignee_name || ""} disabled={true} />
        </div>
        <div className="col-sm-6 col-md-4">
          <InputField label="Shipment Segment" value={enquiry.shipment_segment || ""} disabled={true} />
        </div>
        {["Door to Door", "ICD to Door", "Door to Port", "ICD to Port"].includes(enquiry.incoterm) && (
          <>
            <div className="col-sm-6 col-md-4">
              <InputField label="Place Of Receipt" value={enquiry.place_of_receipt || ""} disabled={true} />
            </div>
            <div className="col-sm-6 col-md-4">
              <InputField label="POR Pin Code" value={enquiry.place_of_receipt_pin || ""} disabled={true} />
            </div>
          </>
        )}
        <div className="col-sm-6 col-md-4">
          <InputField label="Port of Loading" value={enquiry.pol || ""} disabled={true} />
        </div>
        <div className="col-sm-6 col-md-4">
          <InputField label="Port of Discharge" value={enquiry.pod || ""} disabled={true} />
        </div>
        {["Door to Door", "ICD to Door", "Port to Door"].includes(enquiry.incoterm) && (
          <>
            <div className="col-sm-6 col-md-4">
              <InputField label="Final Port Of Delivery" value={enquiry.final_port_of_delivery || ""} disabled={true} />
            </div>
            <div className="col-sm-6 col-md-4">
              <InputField label="FPOD Pin Code" value={enquiry.final_port_of_delivery_pin || ""} disabled={true} />
            </div>
          </>
        )}
        <div className="col-sm-6 col-md-4">
          <InputField label="Freight Terms" value={enquiry.freight_terms || ""} disabled={true} />
        </div>
        <div className="col-sm-6 col-md-4">
          <InputField label="Routing" value={enquiry.routing || ""} disabled={true} />
        </div>
        {["Indirect", "Both"].includes(enquiry.routing) && (
          <div className="col-sm-6 col-md-4">
            <InputField label="Transshipment Hub" value={enquiry.transshipment_hub || ""} disabled={true} />
          </div>
        )}
        {["FE", "LE"].includes(enquiry.shipment_segment) && (
          <div className="col-sm-6 col-md-4">
            <InputField label="Stuffing At" value={enquiry.stuffing_destuffing_At || ""} disabled={true} />
          </div>
        )}
        {["LI", "FI"].includes(enquiry.shipment_segment) && (
          <div className="col-sm-6 col-md-4">
            <InputField label="Destuffing At" value={enquiry.stuffing_destuffing_at || ""} disabled={true} />
          </div>
        )}
        <div className="col-sm-6 col-md-4">
          <InputField label="Nature of Cargo" value={enquiry.nature_of_cargo || ""} disabled={true} />
        </div>
        {enquiry.nature_of_cargo === "Hazardous" && (
          <div className="col-sm-6 col-md-4">
            <InputField label="HAZ Class" value={enquiry.haz_class || ""} disabled={true} />
          </div>
        )}
        <div className="col-sm-6 col-md-4">
          <InputField label="HS Code" value={enquiry.hs_code || ""} disabled={true} />
        </div>
        <div className="col-sm-6 col-md-4">
          <InputField label="HSN Description" value={enquiry.hs_description || ""} disabled={true} />
        </div>
        <div className="col-sm-6 col-md-4">
          <InputField label="Document Type" value={enquiry.document_type || ""} disabled={true} />
        </div>
        {enquiry.document_type === "Original" && (
          <div className="col-sm-6 col-md-4">
            <InputField label="Document Count" value={enquiry.document_count || ""} disabled={true} />
          </div>
        )}
        {enquiry.switch_bl === "Yes" && (
          <div className="col-sm-6 col-md-4">
            <InputField label="Switch BL" value={enquiry.switch_at || ""} disabled={true} />
          </div>
        )}
        <div className="col-sm-6 col-md-4">
          <InputField label="Packaging Type" value={enquiry.packaging_type || ""} disabled={true} />
        </div>
        <div className="col-sm-6 col-md-4">
          <InputField label="Packaging Count" value={enquiry.packaging_count || ""} disabled={true} />
        </div>
        <div className="col-sm-6 col-md-4">
          <InputField label="Goods Value" value={enquiry.goods_value || ""} disabled={true} />
        </div>

        {/* Container Details Section */}
        {enquiry.containerDetails?.length > 0 && (
          <div className="col-12 mt-3">
            <h5 className="mb-2">Container Details</h5>
            <div className="position-relative mb-4">
              <div className="d-flex align-items-start">
                <div className="ovrflx flex-grow-1">
                  <div className="table-responsive">
                    <table className="table table-bordered align-middle">
                      <thead>
                        <tr>
                          {!["LE", "LI"].includes(enquiry.shipment_segment) && (
                            <th>Container Type</th>
                          )}
                          {!["LE", "LI"].includes(enquiry.shipment_segment) && (
                            <th>Gross Cargo Weight</th>
                          )}
                          {!["FE", "FI"].includes(enquiry.shipment_segment) && (
                            <th>Length</th>
                          )}
                          {!["FE", "FI"].includes(enquiry.shipment_segment) && (
                            <th>Breadth</th>
                          )}
                          {!["FE", "FI"].includes(enquiry.shipment_segment) && (
                            <th>Height</th>
                          )}
                          {["LE", "LI"].includes(enquiry.shipment_segment) && (
                            <th>CBM</th>
                          )}
                          {enquiry.nature_of_cargo === "Temperature Control" && (
                            <th>Temperature</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {enquiry.containerDetails.map((container, idx) => (
                          <tr key={idx}>
                            {enquiry.shipment_segment !== "LE" && enquiry.shipment_segment !== "LI" && (
                              <td>{container.container_type || "-"}</td>
                            )}
                            {!["LE", "LI"].includes(enquiry.shipment_segment) && (
                              <td>{container.container_weight}</td>
                            )}
                            {!["FE", "FI"].includes(enquiry.shipment_segment) && (
                              <td>{container.container_length}</td>
                            )}
                            {!["FE", "FI"].includes(enquiry.shipment_segment) && (
                              <td>{container.container_breadth}</td>
                            )}
                            {!["FE", "FI"].includes(enquiry.shipment_segment) && (
                              <td>{container.container_height || "-"}</td>
                            )}
                            {["LE", "LI"].includes(enquiry.shipment_segment) && (
                              <td>
                                {container.container_length && container.container_breadth && container.container_height
                                  ? (
                                      (parseFloat(container.container_length) *
                                        parseFloat(container.container_breadth) *
                                        parseFloat(container.container_height)) /
                                      1000000
                                    ).toFixed(2)
                                  : "0.00"}
                              </td>
                            )}
                            {enquiry.nature_of_cargo === "Temperature Control" && (
                              <td>{container.container_temperature || "-"}</td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="measurement d-none d-lg-block ms-3 flex-shrink-0">
                  <p>1M = 100CM</p>
                  <p>1CM = 10MM</p>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="col-sm-6 col-md-4">
          <InputField label="CHA Services Required" value={enquiry.cha_required || ""} disabled={true} />
        </div>
        <div className="col-sm-6 col-md-4">
          <InputField label="Remarks" value={enquiry.remarks || ""} disabled={true} />
        </div>
      </div>
    </div>
  );
};
 
export default ViewEnquiryDetails;
 
 